import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectShowFeminicidios, setShowFeminicidios, selectHurtoType, setHurtoType, selectComparisonYear, setComparisonYear } from "../../redux/slices/filtersSlice";
import "./DateRangeBar.css";

const DateRangeBar = ({ dates = { start: "", end: "" }, setDates, onChange, topN, setTopN, showToggle = false, showHurtoTypeFilter = false }) => {
  const dispatch = useDispatch();
  const showFeminicidios = useSelector(selectShowFeminicidios);
  const hurtoType = useSelector(selectHurtoType);
  const comparisonYear = useSelector(selectComparisonYear);
  const { start: startDate, end: endDate } = dates;
  const [tempDates, setTempDates] = useState({ start: startDate, end: endDate });
  const [lastValidDates, setLastValidDates] = useState({ start: startDate, end: endDate });
  const [tempComparisonYear, setTempComparisonYear] = useState(comparisonYear);
  const [lastValidComparisonYear, setLastValidComparisonYear] = useState(comparisonYear);
  const [error, setError] = useState("");

  const validateDates = ({ start, end }, yearToCompare) => {
    if (!start || !end) return "⚠️ Debes seleccionar ambas fechas.";

    const startObj = parseLocalDate(start);
    const endObj = parseLocalDate(end);
    if (startObj > endObj) return "⚠️ La fecha de inicio no puede ser posterior a la fecha de fin.";

    if (startObj.getFullYear() !== endObj.getFullYear()) return "⚠️ Las fechas deben estar dentro del mismo año.";

    const dateRangeYear = startObj.getFullYear();
    if (parseInt(yearToCompare) === dateRangeYear) return "⚠️ El año de comparación no puede ser igual al año del rango de fechas.";

    return "";
  };

  const handleChange = (field, value) => {
    setTempDates((prev) => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    const validationError = validateDates(tempDates, tempComparisonYear);

    if (validationError) {
      setError(validationError);
      setTempDates(lastValidDates);
      setTempComparisonYear(lastValidComparisonYear);
      return;
    }
    setError("");
    setDates?.(tempDates);
    setLastValidDates(tempDates);
    dispatch(setComparisonYear(parseInt(tempComparisonYear)));
    setLastValidComparisonYear(tempComparisonYear);
    onChange?.(tempDates);
  };

  const parseLocalDate = (str) => {
    const [y, m, d] = str.split("-").map(Number);
    return new Date(y, m - 1, d);
  };


  return (
    <div className="dashboard-header">

      <div className="date-range-container">
        <label>Rango de fechas:</label>
        <div className="date-range-inputs">
          <input
            type="date"
            value={tempDates.start}
            onChange={(e) => handleChange("start", e.target.value)}
          />
          <span>—</span>
          <input
            type="date"
            value={tempDates.end}
            onChange={(e) => handleChange("end", e.target.value)}
          />
        </div>
        <div className="comparison-year-input">
          <label>Año a comparar:</label>
          <input
            type="number"
            min="2010"
            max="2026"
            value={tempComparisonYear}
            onChange={(e) => setTempComparisonYear(e.target.value)}
          />
        </div>
        <button onClick={handleApply} className="apply-button">
          Aplicar
        </button>
        <div className="topn-inputs">
          <label>Categorías por gráfico:</label>
          <input
            type="number"
            min="1"
            value={topN}
            onChange={(e) => {
              const val = parseInt(e.target.value) || 1;
              setTopN?.(val > 100 ? 100 : val);
            }}
          />
        </div>
        {showToggle && (
          <div className="feminicidios-toggle">
            <label>Vista:</label>
            <select
              value={showFeminicidios ? "feminicidios" : "homicidios"}
              onChange={(e) => dispatch(setShowFeminicidios(e.target.value === "feminicidios"))}
              className="toggle-select"
            >
              <option value="homicidios">Homicidios</option>
              <option value="feminicidios">Feminicidios</option>
            </select>
          </div>
        )}
        {showHurtoTypeFilter && (
          <div className="hurto-type-filter">
            <label>Tipo de hurto:</label>
            <select
              value={hurtoType}
              onChange={(e) => dispatch(setHurtoType(e.target.value))}
              className="toggle-select"
            >
              <option value="Hurto de celular casos">Hurto de celular casos</option>
              <option value="Hurto de celular cantidad">Hurto de celular cantidad</option>
              <option value="Hurto a persona">Hurto a persona</option>
              <option value="Hurto a residencia">Hurto a residencia</option>
              <option value="Hurto a establecimiento comercial">Hurto a establecimiento comercial</option>
              <option value="Hurto de carro">Hurto de carro</option>
              <option value="Hurto de moto">Hurto de moto</option>
              <option value="Hurto de bicicleta cantidad">Hurto de bicicleta cantidad</option>
              <option value="Hurto de bicicleta casos">Hurto de bicicleta casos</option>
              <option value="Hurto a entidad financiera">Hurto a entidad financiera</option>
              <option value="Hurto por piratería terrestre">Hurto por piratería terrestre</option>
            </select>
          </div>
        )}
        {error && (
          <div className="validation-error-message">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export default DateRangeBar;
